import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const LocationProvider = ({ children }) => {

  const location = useLocation();

  return (
    <AnimatePresence>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          key: location.pathname
        });
      })}
    </AnimatePresence>
  );
}

export default LocationProvider;